import { IApiError } from '@/models/apiError.model';
import { ILLMConfig } from '@/models/llmConfig.model';

export const SLICE_NAME = 'llmConfig';

export interface LLMConfigState {
  llmConfig: ILLMConfig | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: LLMConfigState = {
  llmConfig: null,
  isLoading: false,
  error: null,
};
